export default {
  route: {
    login: 'Login',
    redirecting: 'Redirecting...',
    exportImport: 'Export / Import',
    noPermission: 'No permission',
    pageNotFound: 'Page not found',
    purchaseOrders: 'Purchase Orders',
    transferGoodsManagement: 'Transfer Goods Management',
    creditOrders: 'Credit Orders',
    doubleOrders: 'Double Orders',
    createDoubleOrder: 'Create Double Order',
    headOfficeShipment: 'Headquarters Shipment',
    regionalShipmentRecords: 'Regional Shipment Records',
    regionalJdWarehouseShipment: 'Regional JD Warehouse Shipment',
    cloudWarehouseShipmentDetails: 'Cloud Warehouse Shipment Details',
    accountSettlement: 'Account Settlement',
    accountAssetDashboard: 'Account Asset Dashboard',
    maintenanceManagement: 'Maintenance Management',
    callCenterConfig: 'Call Center Configuration',
    noviceTasks: 'New User Tasks',
    dashboard: 'Dashboard',
    analystManagement: 'Analyst Management',
    accountManagement: 'Account Management',
    employeeAccounts: 'Employee Accounts',
    tools: 'Tools',
    organizationArchive: 'Organization Records',
    goldAccountManagement: 'Gold Account Management',
    salesShipment: 'Sales Shipment',
    potentialCustomers: 'Potential Customers',
    leadManagement: 'Lead Management',
    targetManagement: 'Target Management',
    dataReports: 'Data Reports',
    studyMachineManagement: 'Learning Tablet Management',
    takeDelivery: 'Warehouse Pickup',
    newLading: 'Create Pickup Order',
    ladingDetail: 'Pickup Order Details',
    barterManagement: 'Exchange Management',
    teacherChildrenDevice: 'Employee Children Device Management',
    childrenDeviceDetail: 'Children Device Details',
    supervisorManagement: 'Instructor Management',
    studentManagement: 'Student Management',
    addStudentList: 'Add Student List',
    scoreManagement: 'Score Management',
    supervisorData: 'Instructor Data',
    supervisorDetails: 'Instructor Details',
    supervisorSummary: 'Instructor Summary',
    dataLibrary: 'Resource Library',
    assignPermissions: 'Assign Permissions',
    customQuickIdentity: 'Custom Quick Roles',
    employeeLearningAccounts: 'Employee Learning Accounts',
    scoreCollectionTotal: 'Score Collection (Total)',
    supervisorScoreManagement: 'Instructor Score Management',
    videoCallRecord: 'Video Call Records',
    targetSetting: 'Target Setting',
    performanceReview: 'Performance Review',
    basicSettings: 'Basic Settings'
  }
}
